const CHAPTERS_WITH_ASSESSMENTS = new Set([1, 3, 5, 7]);

const chapterMetadata = [
  {
    chapt_num: 1,
    chapt_name: "Prologue",
    subtitle: "Stanzas 1 - 6"
  },
  {
    chapt_num: 2,
    chapt_name: "Parodos",
    subtitle: "Stanza 1"
  },
  {
    chapt_num: 3,
    chapt_name: "Episode 1",
    subtitle: "Stanza 1"
  },
  {
    chapt_num: 4,
    chapt_name: "Stasimon 1",
    subtitle: "Stanza 1"
  },
  {
    chapt_num: 5,
    chapt_name: "Episode 2",
    subtitle: "Stanzas 1 - 11"
  },
  {
    chapt_num: 6,
    chapt_name: "Stasimon 2",
    subtitle: "Stanzas 1 - 2"
  },
  {
    chapt_num: 7,
    chapt_name: "Episode 3",
    subtitle: "Stanza 1"
  },
  {
    chapt_num: 8,
    chapt_name: "Stasimon 3",
    subtitle: "Stanzas 1 - 3"
  },
  {
    chapt_num: 9,
    chapt_name: "Episode 4",
    subtitle: "Stanzas 1 - 5"
  },
  {
    chapt_num: 10,
    chapt_name: "Stasimon 4",
    subtitle: "Stanza 1"
  },
  {
    chapt_num: 11,
    chapt_name: "Episode 5",
    subtitle: "Stanzas 1 - 5"
  },
  {
    chapt_num: 12,
    chapt_name: "Stasimon 5",
    subtitle: "Stanza 1"
  },
  {
    chapt_num: 13,
    chapt_name: "Exodus",
    subtitle: "Stanzas 1 - 8"
  }
];

export const chapters = chapterMetadata.map((chapter, index) => ({
  chapter_id: chapter.chapt_num,
  chapt_num: chapter.chapt_num,
  chapt_name: chapter.chapt_name,
  subtitle: chapter.subtitle,
  stanzaRange: chapter.subtitle,
  hasAssessment: CHAPTERS_WITH_ASSESSMENTS.has(chapter.chapt_num),
  chunk: `chunk${String(index).padStart(2, '0')}`
}));

const getChapterByChunk = (chunk) => chapters.find((ch) => ch.chunk === chunk);

export const config = {
  id: "Antigone",
  displayName: "Antigone",
  author: "Sophocles",
  coverImage: "Antigone.png",
  route: "Antigone",
  type: "drama",
  contentKey: "Antigone",
  bookId: "antigone",
  usesExternalLinks: false,

  getTitleForChunk: function(chunk) {
    const chapter = getChapterByChunk(chunk);
    return chapter ? chapter.chapt_name : "Antigone";
  },

  getSubtitle: function(fragmentRange, _level, _showCefrLevel, chunk) {
    const chapter = getChapterByChunk(chunk);
    if (chapter?.subtitle) {
      return chapter.subtitle;
    }
    if (fragmentRange?.start && fragmentRange?.end) {
      return `Stanzas ${fragmentRange.start} - ${fragmentRange.end}`;
    }
    return "Antigone";
  }
};

const book = { config, chapters };

export default book;
